import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import _Widget from 'dijit/_Widget';
import { FileHelpers, StringHelpers } from "../../../more/Helpers";
import RequestManager from 'more/RequestManager';
import methodHooks from 'more/mdsMethodHooks';


class FileDownloadHandler extends methodHooks(compose(_Widget)) {

    templateString = "<div></div>";
    /**
     * Löst einen "klassichen" Download per URL-Aufruf aus, indem eine Controller-URL (default: Filetransfer/Download) mit direktem Fileresult aufgerufen wird.
     * @param dataOrKey Downloadkey der ans Backend überreicht wird oder Filedescriptor mit downloadKey oder DescriptorRequest mit key.
     * @param customUrl Alternative URL angeben, falls nicht FileTransfer/Download. window.appRoot wird vorangestellt. Wenn die URL einen Platzhalter {0} enthält, wird darin der Downloadkey platziert, zB. MyController/dl?key={0}
     * @returns
     */
    downloadFromUrl(dataOrKey: FileFinder.FileDescriptor | string | FileFinder.DescriptorRequestData, customUrl?: string) {

        let downloadKey: string = "";
        if (!dataOrKey) return;

        else if (typeof (dataOrKey) == "string") {
            downloadKey = dataOrKey;
        }
        else if (dataOrKey["key"]) {
            downloadKey = dataOrKey["key"];
        } else if (dataOrKey["downloadKey"]) {
            downloadKey = dataOrKey["downloadKey"];
        }

        if (downloadKey) {
            if (customUrl) {
                location.href = window.appRoot + StringHelpers.stringFormat(customUrl, encodeURIComponent(downloadKey));
            } else {
                location.href = window.appRoot + StringHelpers.stringFormat("FileTransfer/Download?downloadKey={0}", encodeURIComponent(downloadKey));
            }
            
        }
    }
    /**
     * Löst einen Download für ein bereits im Client geladenes File mit base64-Daten aus.
     * OBSOLET: Kann durch Filehelpers.provideFile abgelöst werden.
     * @deprecated Kann durch Filehelpers.provideFile abgelöst werden.
     */
    downloadFromDescriptor(data: FileFinder.FileDescriptorWithBase64, bOverrideUsePreview?: boolean, alternativePreviewFeaturePath?: string) {
        FileHelpers.provideFile(data, bOverrideUsePreview, alternativePreviewFeaturePath);
        setTimeout(lang.hitch(this, this.destroy), 120 * 1000);
    }

    /**
     * Führt einen standardmäßigen Request für den Download eines Filedescriptors inklusive Base64-Content durch.
     * Als API wird Webtool_API_FileTransfer__DownloadDescriptorByKey aufgerufen
     * @param key Key, unter dem im Backend das File gefunden wird
     * @param resultCallback Callback mit dem erhaltenen Filedescriptor
     * @param errorCallback Callback im Fehlerfall
     */
    downloadFileAsDescriptor(key: string, resultCallback: (result: FileFinder.FileDescriptorWithBase64) => any, errorCallback?: (error: more.requestErrorMessage) => any) {
        if (!key) return;

        let requestData: FileFinder.DescriptorRequestData = {
            key: key
        }
        let requestman = new RequestManager();
        
        requestman.callfunction("Webtool_API_FileTransfer__DownloadDescriptorByKey",
            requestData,
            resultCallback,
            errorCallback ? errorCallback : lang.hitch(this, this._onFileDescriptorError),
            false);
    }

    private _onFileDescriptorError(error: more.requestErrorMessage) {
        alert(error.Message);
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(FileDownloadHandler);
